var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResumeYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9989 9H14.9989C13.342 9 11.9989 10.3431 11.9989 12V60C11.9989 61.6569 13.342 63 14.9989 63H56.9989C58.6557 63 59.9989 61.6569 59.9989 60V12C59.9989 10.3431 58.6557 9 56.9989 9Z",
    fill: "#FFC72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8136 45.375C48.9527 45.375 49.8761 44.4516 49.8761 43.3125C49.8761 42.1734 48.9527 41.25 47.8136 41.25H24.1886C23.0495 41.25 22.1261 42.1734 22.1261 43.3125C22.1261 44.4516 23.0495 45.375 24.1886 45.375H47.8136Z",
    fill: "#FFDA67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8136 54C48.9527 54 49.8761 53.0766 49.8761 51.9375C49.8761 50.7984 48.9527 49.875 47.8136 49.875H24.1886C23.0495 49.875 22.1261 50.7984 22.1261 51.9375C22.1261 53.0766 23.0495 54 24.1886 54H47.8136Z",
    fill: "#FFDA67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0023 25.605C38.1024 25.605 39.8048 23.9026 39.8048 21.8025C39.8048 19.7024 38.1024 18 36.0023 18C33.9023 18 32.1998 19.7024 32.1998 21.8025C32.1998 23.9026 33.9023 25.605 36.0023 25.605Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4369 33.7501H30.5619C30.3074 33.7522 30.056 33.6953 29.8273 33.5838C29.5985 33.4724 29.3987 33.3094 29.2436 33.1077C29.0884 32.9061 28.9821 32.6712 28.933 32.4215C28.8839 32.1719 28.8934 31.9142 28.9606 31.6688C29.8494 28.6238 32.6619 26.5801 35.9994 26.5801C39.3369 26.5801 42.1494 28.6238 43.0381 31.6688C43.1054 31.9142 43.1148 32.1719 43.0657 32.4215C43.0166 32.6712 42.9103 32.9061 42.7552 33.1077C42.6 33.3094 42.4002 33.4724 42.1715 33.5838C41.9428 33.6953 41.6913 33.7522 41.4369 33.7501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResumeYellow);
export default __webpack_public_path__ + "static/media/icon_resume_yellow.8be90a4c.svg";
export { ForwardRef as ReactComponent };